<template>
    <div class="container">
        <div class="card mb-2">
            <div class="card-header py-2 text-muted">
                最新CSVファイルURL
            </div>
            <div class="card-body py-2">
                <a href="https://www.post.japanpost.jp/zipcode/dl/kogaki-zip.html">
                    都道府県一覧
                </a>
                <div>
                    <span class="text-muted">
                        <small> <small>※全国一括をダウロードする</small> </small>
                    </span>
                </div>
            </div>
        </div>
        <div class="card mb-2">
            <div class="card-header py-2 text-muted">
                前回更新情報
            </div>
            <ul class="list-group list-group-flush border-top-0">
                <li class="list-group-item d-flex">
                    <span> 日付 </span>
                    <span class="flex-fill text-right let-space-1 text-muted">
                        <small> 2020/10/10 11:11:15 </small>
                    </span>
                </li>
                <li class="list-group-item d-flex">
                    <span> 件数 </span>
                    <span class="flex-fill text-right let-space-1 text-muted">
                        <small> 1111件 </small>
                    </span>
                </li>
                <li class="list-group-item d-flex">
                    <span> 所要時間 </span>
                    <span class="flex-fill text-right let-space-1 text-muted">
                        <small> 35秒 </small>
                    </span>
                </li>
                <li class="list-group-item d-flex">
                    <span> 開始時間 </span>
                    <span class="flex-fill text-right let-space-1 text-muted">
                        <small> 2020/10/10 11:11:15 </small>
                    </span>
                </li>
                <li class="list-group-item d-flex">
                    <span> 終了時間 </span>
                    <span class="flex-fill text-right let-space-1 text-muted">
                        <small> 2020/10/10 11:11:15 </small>
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {

    }
</script>

<style>
</style>
